import type { FC } from "react";
import PropTypes from "prop-types";
import Settings03Icon from "@untitled-ui/icons-react/build/esm/Settings03";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WHATSAPP_GREEN = "#25D366";

interface SettingsButtonProps {
  onClick?: () => void;
}

export const SettingsButton: FC<SettingsButtonProps> = (props) => (
  <Tooltip title="Contact Helpdesk">
    <Box
      sx={{
        backgroundColor: "background.paper",
        borderRadius: "50%",
        bottom: 0,
        boxShadow: 16,
        margin: (theme) => theme.spacing(4),
        position: "fixed",
        right: 0,
        zIndex: (theme) => theme.zIndex.speedDial,
      }}
      // {...props}
    >
      <ButtonBase
        sx={{
          backgroundColor: WHATSAPP_GREEN,
          borderRadius: "50%",
          color: "common.white",
          p: "15px",
          transition: "background-color 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "#1DA851",
          },
        }}
        href="https://wa.me/31639202608"
        target="_blank noopener noreferrer"
      >
        <SvgIcon
          sx={{
            fontSize: "2.5rem",
          }}
        >
          <WhatsAppIcon />
        </SvgIcon>
      </ButtonBase>
    </Box>
  </Tooltip>
);

SettingsButton.propTypes = {
  onClick: PropTypes.func,
};
